export default __webpack_public_path__ + "static/media/API.c13f68fa.png";